// conditions
export const NOT_APPLICABLE = 0
export const MATCH_REGULAR_EXPRESSION = 1
export const EQUALS = 2
export const NOT_EQUALS = 3
export const CONTAINS = 4
export const NOT_CONTAINS = 5

// action
export const SHOW = "EPiServer.Forms.Core.Internal.Dependency.ShowAction"
export const HIDE = "EPiServer.Forms.Core.Internal.Dependency.HideAction"

// condition combination
export const ALL = 0
export const ANY = 1

export const DependConditionDescriptions = {
  [NOT_APPLICABLE]: "Not applicable",
  [MATCH_REGULAR_EXPRESSION]: "Match regular expression",
  [EQUALS]: "Equals",
  [NOT_EQUALS]: "Not equals",
  [CONTAINS]: "Contains",
  [NOT_CONTAINS]: "Not contains",
}

export const SatisfiedActionDescriptions = {
  [SHOW]: "Show if conditions are met",
  [HIDE]: "Hide if conditions are met",
}

export const ConditionCombinationDescriptions = {
  [ALL]: "All conditions are met",
  [ANY]: "Any condition is met",
}

export const getConditionDescription = (condition) => {
  return DependConditionDescriptions[condition] || "Unknown condition"
}

export const getSatisfiedActionDescription = (action) => {
  return SatisfiedActionDescriptions[action] || "Unknown action"
}

export const getConditionCombinationDescription = (combination) => {
  return ConditionCombinationDescriptions[combination] || "Unknown combination"
}

export const evaluateCondition = (condition, inputValue, targetValue) => {
  switch (condition) {
    case EQUALS:
      return inputValue && inputValue === targetValue
    case NOT_EQUALS:
      return inputValue && inputValue !== targetValue
    case CONTAINS:
      return inputValue && inputValue.includes(targetValue)
    case NOT_CONTAINS:
      return inputValue && !inputValue.includes(targetValue)
    case MATCH_REGULAR_EXPRESSION:
      return inputValue && new RegExp(targetValue).test(inputValue)
    default:
      return true // Default for non-applicable or unknown cases
  }
}

const formatFieldKey = (fieldId) => `__field_${fieldId}`

export const evaluateDependencies = (dependencies, formValues, conditionCombination) => {
  const results = dependencies?.map((dependency) => {
    const fieldKey = formatFieldKey(dependency.field)
    const inputValue = formValues[fieldKey]
    return evaluateCondition(dependency.operator, inputValue, dependency.value)
  })

  return conditionCombination === ALL ? results.every(Boolean) : results.some(Boolean)
}

export const shouldDisplayField = (formField, formValues) => {
  const { dependencies, satisfiedAction, conditionCombination } = formField
  if (!dependencies) return true
  const dependenciesMet = evaluateDependencies(dependencies, formValues, conditionCombination)

  if (satisfiedAction === SHOW) {
    return dependenciesMet
  } else if (satisfiedAction === HIDE) {
    return !dependenciesMet
  }
  return true
}
